var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronBackOtherProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7958_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16744 0.468747L1.0972 5.36017C0.392974 6.07119 -3.55331e-07 7.01668 -3.16436e-07 8C-2.77541e-07 8.98332 0.392974 9.92881 1.0972 10.6398L6.16744 15.5313C6.47861 15.8314 6.90065 16 7.34072 16C7.78079 16 8.20283 15.8314 8.51401 15.5313C8.82518 15.2311 9 14.824 9 14.3996C9 13.9751 8.82518 13.5681 8.51401 13.2679L3.44267 8.37651C3.33901 8.2765 3.28078 8.14088 3.28078 7.99947C3.28078 7.85805 3.33901 7.72243 3.44267 7.62242L8.51401 2.73207C8.82518 2.43193 9 2.02486 9 1.60041C9 1.17595 8.82518 0.768881 8.51401 0.468747C8.20283 0.168611 7.78079 -3.75852e-07 7.34072 -3.54594e-07C6.90065 -3.33337e-07 6.47861 0.168611 6.16744 0.468747Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7958_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBackOtherProfile);
export default __webpack_public_path__ + "static/media/chevron-back-other-profile.e1db1ad81bd43aff99b0c6979ab8e69d.svg";
export { ForwardRef as ReactComponent };